import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "@/context/AuthContext";
import { ProtectedRoute } from "@/components/ProtectedRoute";
import Home from "@/pages/Home";
import Booking from "@/pages/Booking";
import ManageBooking from "@/pages/ManageBooking";
import Login from "@/pages/Login";
import ForgotPassword from "@/pages/ForgotPassword";
import ResetPassword from "@/pages/ResetPassword";
import Legal from "@/pages/Legal";
import Dashboard from "@/pages/Dashboard";
import Settings from "@/pages/Settings";
import Billing from "@/pages/Billing";
import Clients from "@/pages/Clients";
import Stats from "@/pages/Stats";
import Admin from "@/pages/Admin";

function App() {
  return (
    <AuthProvider>
      <BrowserRouter basename="/dark">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/reservation" element={<Booking />} />
          <Route path="/salon/:slug" element={<Home />} />
          <Route path="/salon/:slug/reservation" element={<Booking />} />
          <Route path="/mon-rendez-vous/:token" element={<ManageBooking />} />
          <Route path="/login" element={<Login />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/reset-password" element={<ResetPassword />} />
          <Route path="/mentions-legales" element={<Legal doc="mentions" />} />
          <Route path="/confidentialite" element={<Legal doc="confidentialite" />} />
          <Route path="/cgv" element={<Legal doc="cgv" />} />
          <Route path="/salon/:slug/mentions-legales" element={<Legal doc="mentions" />} />
          <Route path="/salon/:slug/confidentialite" element={<Legal doc="confidentialite" />} />
          <Route path="/salon/:slug/cgv" element={<Legal doc="cgv" />} />
          <Route path="/admin" element={<ProtectedRoute requireRole="super_admin"><Admin /></ProtectedRoute>} />
          <Route path="/dashboard" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
          <Route path="/dashboard/clients" element={<ProtectedRoute><Clients /></ProtectedRoute>} />
          <Route path="/dashboard/stats" element={<ProtectedRoute><Stats /></ProtectedRoute>} />
          <Route path="/dashboard/billing" element={<ProtectedRoute><Billing /></ProtectedRoute>} />
          <Route path="/dashboard/settings" element={<ProtectedRoute><Settings /></ProtectedRoute>} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
